import React from "react";
import { useCreditPaymentContext } from "./CreditPaymentContext";
import { ArrowpayPaymentForm } from "./ArrowpayPaymentForm";
import { ArrowPayDigitalPaymentForm } from "./ArrowPayDigitalPaymentForm";
import { CayanPaymentForm } from "./CayanPaymentForm";
import { Shift4HostedPaymentForm } from "./Shift4HostedPaymentForm";
import { VantivHostedPaymentForm } from "./VantivHostedPaymentForm";
import { XplorPayPaymentForm } from "./XplorPayPaymentForm";
var processorStrategies = {
    vantiv: VantivHostedPaymentForm,
    cayan: CayanPaymentForm,
    shift4: Shift4HostedPaymentForm,
    arrowpay: ArrowpayPaymentForm,
    xplorpay: XplorPayPaymentForm,
};
var isProcessorKey = function (value) {
    return typeof value === "string" && value in processorStrategies;
};
/*
Determines which component to render based on a given processor key.
 */
export var CreditPaymentForm = function () {
    var _a = useCreditPaymentContext(), processorInfo = _a.processorInfo, selectedPaymentType = _a.selectedPaymentType;
    var processorKey = isProcessorKey(processorInfo === null || processorInfo === void 0 ? void 0 : processorInfo.processor) ? processorInfo.processor : null;
    var isDigitalWalletPayment = selectedPaymentType === "apple_pay" || selectedPaymentType === "google_pay";
    var PaymentForm = processorKey ? processorStrategies[processorKey] : null;
    if (processorKey === "arrowpay" && isDigitalWalletPayment) {
        return React.createElement(ArrowPayDigitalPaymentForm, null);
    }
    return PaymentForm ? React.createElement(PaymentForm, null) : null;
};
